/**
 * Environment and path resolution utility functions.
 */
define(
    'plugins/musicfavourite/env',['exports', 'module'],
    function(exports, module) {

        'use strict';

        var BASE_DIR = '/modules/plugin/musicfavourite',
            hostnameRegex = new RegExp('^([^:]+://[^/]+)(' + BASE_DIR + '/[^/]+)'); // (hostname)(/basedir/version)

        /**
         * Retrieves the module object used for environment checks.
         * Can be stubbed for tests.
         *
         * @return {object}
         */
        exports.getModule = function() {
            return module;
        };


        /**
         * Retrieves the window.location object for environment checks.
         * Can be stubbed for tests.
         *
         * @return {object}
         */
        exports.getLocation = function() {
            return window.location;
        };

        /**
         * Returns the favourite API hostname for the current environment.
         *
         * @return {string}
         */
        exports.getApiHost = function() {
            return window.API_HOST_PREFIX || '';
        };

        /**
         * Returns the static assets hostname for the current environment.
         *
         * @return {string}
         */
        exports.getStaticHost = function() {
            return window.STATIC_HOST_PREFIX || '';
        };

        /**
         * Resolves a relative URL against the PAL API or static assets host.
         *
         * @param {string} url Relative URL to resolve.
         * @param {string} host Hostname to resolve against.
         * @return {string|undefined} Resolved URL or undefined when not passed a string.
         */
        exports.resolveURL = function(url, host) {
            if (typeof(url) !== 'string') {
                return undefined;
            }

            host = host || exports.getStaticHost();

            var base = (url.charAt(0) === '/') ? '' : BASE_DIR;
            return [host, base, url].join('');
        };

        /**
         * Resolves a relative URL against the PAL API host as determined by the environment.
         *
         * @param {string} url Relative URL to resolve.
         * @return {string|undefined} Resolved URL or undefined when not passed a string.
         */
        exports.resolveApiURL = function(url) {
            return exports.resolveURL(url, exports.getApiHost());
        };

        /**
         * Resolves a relative or host absolute path to a static resource.
         *
         * @param  {string} path Path to static resource.
         * @return {string|undefined} Full canonical URL of the resource or undefined when not passed a string.
         */
        exports.resolveStaticURL = function(path) {
            if (typeof path !== 'string') {
                return undefined;
            }

            var module = exports.getModule(),
                uri = module && module.uri || '';

            if (hostnameRegex.test(uri)) {
                var matches = hostnameRegex.exec(uri);
                if (matches) {
                    return matches[1] + (path.charAt(0) === '/' ? '' : matches[2] + '/') + path;
                }
            }

            return undefined;
        };

        return exports;
    }
);

